import { log } from 'protocol-setup/helpers';
import React from 'react';
import { useSWRConfig } from 'swr';

export default function SWRCacheViewer() {
  const { cache } = useSWRConfig();
  
  // Convert cache to a plain object for DevTools
  const cacheSnapshot = cache instanceof Map ? Object.fromEntries(Array.from(cache)) : {};

  // This will show up in React DevTools
  return (
    <div style={{ display: 'none' }}>
     {log(cacheSnapshot)}
    </div>
  );
}